storeObject